import { EventStatus } from '@/types/events'

interface StatusBadgeProps {
  status: EventStatus
}

export function StatusBadge({ status }: StatusBadgeProps) {
  let color = ''
  switch (status) {
    case 'live':
      color = 'bg-green-500'
      break
    case 'draft':
      color = 'bg-gray-400'
      break
    case 'archived':
      color = 'bg-blue-500'
      break
    case 'purged':
      color = 'bg-red-300'
      break
    default:
      color = 'bg-gray-400'
  }

  return (
    <div className="flex items-center">
      <div className={`w-2 h-2 rounded-full mr-2 ${color}`} />
      <span className="capitalize">{status}</span>
    </div>
  )
}
